module.exports = __webpack_public_path__ + "img/78_27.0ce6fed1.png";